import { useAuth0 } from '@auth0/auth0-react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PrerenderedThoughtSpotProvider } from '@/components/Thoughtspot/PreRenderedAppEmbed';

export const Route = createFileRoute('/dashboard/_thoughtspot')({
  component: ThoughtSpotLayout,
});

/**
 * Layout component that provides the ThoughtSpot prerendered embed context
 * to child routes that need to use the shared ThoughtSpot iframe.
 *
 * This layout should only wrap routes that utilize the prerendered embed
 * with path navigation (e.g., ThoughtSpot pages accessed via the $page route).
 * Routes that use direct embed components (LiveboardEmbed, SearchEmbed, AppEmbed)
 * should not be wrapped in this layout as they manage their own iframes.
 */
function ThoughtSpotLayout() {
  const { isAuthenticated } = useAuth0();

  return (
    <PrerenderedThoughtSpotProvider isAuthenticated={isAuthenticated}>
      <Outlet />
    </PrerenderedThoughtSpotProvider>
  );
}
